<template>
  <div class="border-form radius-6 product-ticket" :class="{'opacity-04 cursor-disabled': is_product_not_available}">
    <div class="row">
      <div class="col-9">
        <div class="py-4 pl-4">
          <div class="w-100">
            <div class="row no-gutters">
              <div class="col-5">
                <p class="mb-2 sub-heading-1-2">{{ data.name }}</p>
                <ul class="pl-3 my-2 mb-3">
                  <li><p class="mb-0 body-2-2 responsive">{{ lowest_variant.is_refundable ? $t('merchant.refundable') : $t('merchant.non-refundable') }}</p></li>
                  <li v-if="$isNotEmpty(lowest_variant.validity_term)"><p class="mb-0 body-2-2 responsive">{{lowest_variant.validity_term}}</p></li>
                </ul>
                <p class="overline mb-0 text-green cursor-pointer text-uppercase">View Details</p>
              </div>
              <div class="col-7">
                <div class="row no-gutters mb-2">
                  <div class="col-2 align-self-center lh-1 text-right">
                    <svg class="lh-1" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_395_13)">
                        <path
                          d="M6 12C9.28238 12 12 9.27651 12 6C12 2.71765 9.27651 0 5.99413 0C2.71765 0 0 2.71765 0 6C0 9.27651 2.72353 12 6 12Z"
                          fill="#6EA8FB" />
                      </g>
                      <defs>
                        <clipPath id="clip0_395_13">
                          <rect width="12" height="12.0059" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div class="col-8 align-self-center" style="padding-bottom: 12px;">
                    <div class="mx-2">
                      <div class="w-100 border-2-bottom-dashed text-center">
                        <p class="body-3-1 mb-0">{{ formatDuration() }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-2 align-self-center lh-1">
                    <svg class="lh-1" width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C2.68286 0 0 2.68286 0 6C0 10.5 6 17.1429 6 17.1429C6 17.1429 12 10.5 12 6C12 2.68286 9.31714 0 6 0ZM1.71429 6.00001C1.71429 3.63429 3.63429 1.71429 6.00001 1.71429C8.36572 1.71429 10.2857 3.63429 10.2857 6.00001C10.2857 8.46858 7.81715 12.1629 6.00001 14.4686C4.21715 12.18 1.71429 8.44286 1.71429 6.00001ZM3.85715 6.00001C3.85715 4.81654 4.81654 3.85715 6.00001 3.85715C6.76558 3.85715 7.47299 4.26558 7.85577 4.92858C8.23856 5.59158 8.23856 6.40843 7.85577 7.07143C7.47299 7.73444 6.76558 8.14286 6.00001 8.14286C4.81654 8.14286 3.85715 7.18347 3.85715 6.00001Z" fill="#F66464"/>
                    </svg>
                  </div>
                </div>
                <div class="row no-gutters">
                  <div class="col-4 text-center">
                    <div style="padding-right: 6px;">
                      <p class="text-20 font-lato text-dark mb-1 lh-1 ls-0-5">{{ formatTime(lowest_variant.route_from_time) }}</p>
                      <p class="body-3 mb-0">{{ lowest_variant.route_from.name }}</p>
                    </div>
                  </div>
                  <div class="col-4 offset-4 text-center">
                    <div style="padding-left: 6px;">
                      <p class="text-20 font-lato text-dark mb-1 lh-1 ls-0-5">{{ formatTime(lowest_variant.route_to_time) }}</p>
                      <p class="body-3 mb-0">{{ lowest_variant.route_to.name }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="w-100 mt-4 pt-4 border-2-top-dashed" v-if="is_product_in_cart">
            <div 
              class="w-100" 
              v-for="(variant,variant_index) in data.variants"
              :class="{
                'mb-md-4 mb-3 pb-md-4 pb-3 border-b-semi-grey': (variant_index+1) < data.variants.length
              }">
              <Variant :data="variant" :product="data"></Variant>
            </div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="p-4 h-100 bg-custom-light">
          <div class="row no-gutters" v-if="!is_product_in_cart">
            <div class="col-md-12 col-8 mb-md-3 mb-0 align-self-center text-md-center text-left">
              <p class="body-3-3-1 mb-0">Starting from</p>
              <p class="mb-0 text-20 text-green font-lato lh-1">{{ $formatCurrency(lowest_variant.price_sell_discount) }}</p>
            </div>
            <div class="col-md-12 col-4 align-self-center">
              <button class="g-btn g-btn-md g-btn-secondary w-100" @click="selectVariant">Select</button>
            </div>
          </div>
          <div class="row no-gutters" v-else>
            <div class="col-md-12 col-8 mb-md-3 mb-0 align-self-center text-md-center text-left">
              <p class="body-3-3-1 mb-0">Total Selected</p>
              <p class="mb-0 text-20 text-green font-lato lh-1">{{ $formatCurrency(total_price_selected) }}</p>
            </div>
            <div class="col-md-12 col-4 align-self-center">
              <button class="g-btn g-btn-md g-btn-dark-outline w-100" @click="resetSelectedProduct('departure')">Cancel</button>
              <button class="g-btn g-btn-md g-btn-primary w-100 mt-3" v-if="getTicketFilterTransport.is_return" @click="loadProductReturn">Select Return</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapGetters, mapMutations } from 'vuex';
  import Variant from './variantTransport'

  export default {
    props: ['data'],
    components:{
      Variant
    },
    computed:{
      ...mapGetters(['getTicketTransportCart','isTicketTransportCartDeparture','getTicketFilterTransport']),
      lowest_variant(){
        let return_data = {}

        if(this.data.variants.length > 0){
          let copied_data = this.$deepCopy(this.data.variants)
          let sorted = copied_data.sort((a,b)=>Number(a.price_sell_discount)-Number(b.price_sell_discount))
          return_data = sorted[0]
        }
        
        return return_data
      },
      is_product_in_cart(){
        let return_data = false
        if(this.isTicketTransportCartDeparture && this.getTicketTransportCart.departure.product.id == this.data.id){
          return_data = true
        }
        return return_data
      },
      is_product_not_available(){
        return this.isTicketTransportCartDeparture && !this.is_product_in_cart
      },
      total_price_selected(){
        let total = 0
        if(this.is_product_in_cart){
          let departure_product = this.getTicketTransportCart.departure
          departure_product.variant.forEach(item=>{
            total += (item.data.price_sell_discount*item.qty)
          })
        }
        return total
      },
    },
    methods:{
      ...mapMutations(['addTicketTransport','resetTicketTransport']),
      formatTime(time){
        return moment(time,"HH:mm:ss").format("HH:mm")
      },
      formatDuration(){
				let start_formatted = moment(this.lowest_variant.route_from_time,"HH:mm:ss")
				let end_formatted = moment(this.lowest_variant.route_to_time,"HH:mm:ss")
        let formatted = moment.duration(end_formatted.diff(start_formatted))
        let return_data = `${formatted.minutes()} ${this.$t('general.minutes')}`
        
        if(Number(formatted.hours()) > 0){
          return_data = `${formatted.hours()}h `  
        }
        if(Number(formatted.minutes()) > 0){
          return_data += `${formatted.minutes()}m`
        }
        return return_data
			},
      selectVariant(){
        if(!this.is_product_not_available){
          let data = {
            type: 'departure',
            product: this.$deepCopy(this.data),
            variant: this.lowest_variant
          }
          this.addTicketTransport(data)
        }
			},
      resetSelectedProduct(type){
        this.resetTicketTransport(type)
      },
      loadProductReturn(){
        this.$emit('loadProductReturn',true)
      }
    }
  }
</script>
<style>
.opacity-04{
  opacity: 0.4;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/productTransport.vue